import { useMemo } from 'react';
import styled from 'styled-components';
import { SoilAttributeData } from '../../types/soilAttributes';
import { formatReportDescription } from '../../utils/soils';
import { UncontrolledWhiteTooltip } from '../basics/WhiteTooltip';

const ScrollableTooltip = styled(UncontrolledWhiteTooltip)`
  .tooltip-inner {
    background-color: #eeeeee;
    overflow-y: auto;
    max-height: 80vh;
  }
`;

const LearnAboutAttributeButton = ({
  activeData,
}: {
  activeData: Nullable<SoilAttributeData>;
}) => {
  const description = useMemo(
    () =>
      activeData?.description ||
      formatReportDescription(activeData?.reportDescription),
    [activeData],
  );

  if (!description) return null;
  return (
    <>
      <div id="learnAboutAttribute" className="font-small text-muted mt-2">
        LEARN ABOUT ATTRIBUTE
      </div>
      <ScrollableTooltip
        autohide={false}
        flip={false}
        modifiers={{ preventOverflow: { boundariesElement: 'viewport' } }}
        placement="left"
        target="learnAboutAttribute"
        $maxWidth="600px"
      >
        {description}
      </ScrollableTooltip>
    </>
  );
};

export default LearnAboutAttributeButton;
